import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconRepeatOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconRepeatOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-repeat-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M2.2218 2.22162C2.48807 1.95536 2.90473 1.93115 3.19834 2.149L3.28246 2.22162L17.7782 16.7173L17.8508 16.8014C18.0686 17.095 18.0444 17.5117 17.7782 17.778C17.5119 18.0442 17.0952 18.0684 16.8016 17.8506L16.7175 17.778L13.8641 14.9258C13.6775 14.9582 13.4873 14.9803 13.2942 14.9914L13.0024 14.9998L8.56056 14.999L9.78031 16.2195C10.0466 16.4857 10.0708 16.9024 9.85293 17.196L9.78031 17.2801C9.51404 17.5464 9.09738 17.5706 8.80377 17.3527L8.71965 17.2801L6.21965 14.7801C5.95338 14.5139 5.92917 14.0972 6.14703 13.8036L6.21965 13.7195L8.71965 11.2195C9.01254 10.9266 9.48741 10.9266 9.78031 11.2195C10.0466 11.4857 10.0708 11.9024 9.85293 12.196L9.78031 12.2801L8.56056 13.499H12.4376L5.69111 6.75177C4.46155 7.2468 3.57779 8.41976 3.50274 9.80776L3.49756 9.9998C3.49756 11.0829 3.98957 12.0512 4.76229 12.6932C4.90848 12.8287 4.99998 13.0236 4.99998 13.2398C4.99998 13.654 4.66419 13.9898 4.24998 13.9898C4.05869 13.9898 3.88413 13.9182 3.75164 13.8003C2.67864 12.887 1.99756 11.523 1.99756 9.9998C1.99756 8.12031 3.03457 6.48303 4.56763 5.62892L2.2218 3.28228L2.14918 3.19816C1.93133 2.90455 1.95554 2.48789 2.2218 2.22162ZM15.75 6.0098C15.9293 6.0098 16.0939 6.07272 16.2229 6.17768C17.3108 7.09163 18.0024 8.46495 18.0024 9.9998C18.0024 11.5196 17.3243 12.881 16.2542 13.798L15.1888 12.733C15.9896 12.0916 16.5024 11.1056 16.5024 9.9998C16.5024 8.91912 16.0126 7.95284 15.2429 7.31081C15.0935 7.17518 15 6.97841 15 6.7598C15 6.34558 15.3358 6.0098 15.75 6.0098ZM10.2196 2.71947C10.4859 2.4532 10.9026 2.42899 11.1962 2.64685L11.2803 2.71947L13.7803 5.21947L13.8529 5.30359C14.0466 5.56457 14.049 5.92279 13.8601 6.18618L13.7803 6.28013L11.2803 8.78013L11.2556 8.80095L10.1986 7.74395L10.2196 7.71947L11.4386 6.49895H8.95256L7.45156 4.99895H11.4386L10.2196 3.78013L10.147 3.69601C9.92918 3.4024 9.95338 2.98573 10.2196 2.71947Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-repeat-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-repeat-off", "wpp-icon-repeat-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-repeat-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-repeat-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconRepeatOff$1);
      }
      break;
  } });
}

const WppIconRepeatOff = WppIconRepeatOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconRepeatOff, defineCustomElement };
